import { OAuth2 } from '@backstage/core-app-api';
import { SignInPage } from '@backstage/core-components';
import {
  BackstageIdentityApi,
  OpenIdConnectApi,
  ProfileInfoApi,
  SessionApi,
  useApi,
} from '@backstage/core-plugin-api';
import { createApp } from '@backstage/frontend-defaults';
import {
  ApiBlueprint,
  configApiRef,
  createApiRef,
  createFrontendModule,
  discoveryApiRef,
  oauthRequestApiRef,
} from '@backstage/frontend-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import notificationsPlugin from '@backstage/plugin-notifications/alpha';
import searchPlugin from '@backstage/plugin-search/alpha';
import { navModule } from './modules/nav';
import { homeModule } from './modules/home';

const authentikAuthApiRef = createApiRef<
  OpenIdConnectApi & ProfileInfoApi & BackstageIdentityApi & SessionApi
>().with({ id: 'auth.authentik' });

const authentikAuthApi = ApiBlueprint.make({
  name: 'authentik',
  params: defineParams =>
    defineParams({
      api: authentikAuthApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        oauthRequestApi: oauthRequestApiRef,
        configApi: configApiRef,
      },
      factory: ({ discoveryApi, oauthRequestApi, configApi }) =>
        OAuth2.create({
          configApi,
          discoveryApi,
          oauthRequestApi,
          environment: configApi.getOptionalString('auth.environment'),
          provider: {
            id: 'oidc',
            title: 'Authentik',
            icon: () => null,
          },
          defaultScopes: ['openid', 'profile', 'email'],
        }),
    }),
});

const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => props => {
      const configApi = useApi(configApiRef);
      if (configApi.getOptionalString('auth.environment') === 'production') {
        return (
          <SignInPage
            {...props}
            provider={{
              id: 'authentik-auth-provider',
              title: 'Authentik',
              message: 'Sign in with Authentik',
              apiRef: authentikAuthApiRef,
            }}
          />
        );
      }
      return <SignInPage {...props} providers={['guest']} />;
    },
  },
});

export default createApp({
  features: [
    catalogPlugin,
    notificationsPlugin,
    searchPlugin,
    navModule,
    homeModule,
    createFrontendModule({
      pluginId: 'app',
      extensions: [authentikAuthApi, signInPage],
    }),
  ],
});
